import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

//Styles
import './index.scss';

const generateRandomColor = () => {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    const alpha = Math.random().toFixed(2);

    const color = `rgba(${red}, ${green}, ${blue}, ${alpha})`;

    return color;
}

const Gadget = (props) => {

    const { title, labels } = props
    let data = props?.data && props?.data?.length && props?.data?.map((item) => item === null ? 0 : item)

    let color = generateRandomColor();
    return (
        <div className="gadget-container">
            <Line
                options={{
                    responsive: true,
                    scales: {
                        x: {
                            stepSize: 10,
                            display: false,
                        },
                        y: {
                            suggestedMin: 0,
                            min: 0,
                            
                        },
                    },
                }}
                data={{
                    labels,
                    datasets: [
                        {
                            label: title,
                            data: data,
                            borderColor: props.color || color,
                            backgroundColor: props.color || color,
                            borderWidth: 1,
                            pointRadius: 1,
                            fill: false,
                            tension: 0.4,
                        }
                    ],
                }} />
        </div>
    )
}

export default Gadget;